import { graphql } from '../graphql';

export const startLayerStack = graphql(`
  mutation StartLayerStack($input: StartLayerStackInput!) {
    startLayerStack(input: $input)
  }
`);
